import { DIGITS_CHAR_CODES } from '../../constants';

export default {
    directives: {
        numericOnly: {
            bind(el) {
                el.type = 'number';
                el.addEventListener('input', () => {
                    el.value = parseInt(el.value.replace(/[^0-9]/g, ''));
                });
                el.addEventListener('keypress', e => {
                    let charCode = e.which ? e.which : e.keyCode;
                    if (!DIGITS_CHAR_CODES.includes(charCode)) {
                        e.preventDefault();
                    }
                });
            },
        },

        focusUpdated: {
            update(el) {
                el.focus();
            },
        },

        focusInserted: {
            inserted(el) {
                el.focus();
            },
        },
    },
};
